module.exports = __webpack_public_path__ + "img/onlineresume.4741761b.svg";